export const BASE_URL       = 'https://www.ahlamakom.com/api';
export const FACEBOOK_ID    = '9112065352231950'
export const GOOGLE_ID      = '1076026250301-4h0cp3434t5uk5817kvkkuq11188i87c.apps.googleusercontent.com'
export const USER_HOST      = 'https://evusers.electronicvillage.org'
export const RECAPTCHA      = '6LeEz_0hAAAAALYs3I-jTE3dvdC6JNAWnnD1jUUK'
export const APP_ID         = '35'